import {RulesState, RootState, DeviceVersionRule, SchemaField } from '@/types';
import { GetterTree, MutationTree, ActionTree, Module } from 'vuex';
import RulesService from '@/services/rules.service';

type RulesGetter = GetterTree<RulesState, RootState>;

export const initialState = (): RulesState => {
  return {
    initialState,
    rules: [],
    ruleConditions: [],
    uplinkSchemas: [],
  };
};

export const getters: RulesGetter = {
  deviceRules: (state) => state.rules,
  deviceUplinkSchemas: (state) => state.uplinkSchemas,
};

export const mutations: MutationTree<RulesState> = {
  addRules(state, newRules) {
    state.rules = newRules;
  },
  createRule(state, rule) {
    state.rules.push(rule);
  },
  updateRule(state, updatedRule) {
    state.rules[state.rules.findIndex((rule: DeviceVersionRule) => rule.id === updatedRule.id)] = updatedRule;
  },
  addUplinkSchemas(state, schemas) {
    state.uplinkSchemas = schemas;
  },
  removeRule(state, ruleId) {
    state.rules = state.rules.filter((rule: DeviceVersionRule) => rule.id !== ruleId);
  },
};

export const actions: ActionTree<RulesState, RootState> = {
  async addRulesAsync(context: any, id: number) {
    const rulesResp = await RulesService.getDeviceRules(id);
    context.commit('addRules', rulesResp);
    return rulesResp;
  },
  async createRuleAsync(context: any, rule: { deviceId: number, body: DeviceVersionRule }) {
    const response = await RulesService.createRule(rule.deviceId, rule.body);
    context.commit('createRule', response);
    return response;
  },
  async updateRuleAsync(context: any, rule: { id: number, body: DeviceVersionRule }) {
    const response = await RulesService.updateRule(rule.id, rule.body);
    context.commit('updateRule', response);
    return response;
  },
  async removeRuleAsync(context: any, id: number) {
    const success = await RulesService.deleteRule(id);
    context.commit('removeRule', success);
    return success;
  },
  async addUplinkSchemasAsync(context: any, id: number) {
    const deviceVersion = await RulesService.getDevice(id);
    if (deviceVersion.schema_fields) {
      const schemas = deviceVersion.schema_fields.filter((schema: SchemaField) => schema.direction === 'uplink');
      context.commit('addUplinkSchemas', schemas);
      return schemas;
    }
  },
};

export const rules: Module<RulesState, RootState> = {
  state: initialState(),
  getters,
  mutations,
  actions,
};
